import userData         from './user-data'
import userContact      from './user-contact'
import userAddress      from './user-address'
import userAccessData   from './user-access-data'
import userManager      from './user-manager'
import userProfile      from './user-profile'


export {
    userData,
    userContact,
    userAddress,
    userAccessData,
    userManager,
    userProfile
    
}